import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {subjects as S, permissionTypes as T} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import {deletePriceQuote} from '../../_redux/actions/PriceQuotesPageTableActions';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupDeletePriceQuote = ({data}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const intl = useIntl();
  const {priceQuoteID, sentTo, sentDate} = data;
  const handleDeletePriceQuote = () => {
    dispatch(deletePriceQuote(priceQuoteID));
    handleCloseModal();
  };
  const popupMessage = [
    intl.formatMessage({id: 'price-quotes-page-popup-message-delete', defaultMessage: 'Delete price quote?'}),
    priceQuoteID ? ` ${priceQuoteID}?` : '?',
  ].filter(Boolean).join('');

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        title={TTS.DELETE_PRICE_QUOTE}
        disabled={!can(T.FULL, S.PRICE_QUOTES_PAGE) || sentTo || sentDate}
        onClick={handleShowModal}
        label={<img src={toAbsoluteUrl('media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={popupMessage}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={intl.formatMessage({id: 'no', defaultMessage: 'No'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={handleDeletePriceQuote}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: 'yes', defaultMessage: 'Yes'})}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupDeletePriceQuote;
